<div class="form-group" [formGroup]="formGroup" *ngIf="formGroup">
    <label [for]="controlName" class="form-control-label">
        {{ label }}
        <span class="text-danger" *ngIf="isRequired">*</span>
    </label>

    <input
        [id]="controlName"
        type="text"
        class="form-control"
        [ngbTypeahead]="search"
        [formControlName]="controlName"
        [resultFormatter]="formatter"
        [inputFormatter]="formatter"
        [ngClass]="{
            'is-invalid':
                (formControl?.invalid &&
                    (formControl?.dirty || formControl?.touched || changeText)) ||
                searchFailed
        }"
        [placeholder]="'Digite para buscar...'"
        (selectItem)="onSelect($event)" />

    <div class="invalid-feedback" *ngIf="searchFailed">
        Erro ao buscar os dados. Tente novamente.
    </div>
    <div class="invalid-feedback" *ngIf="formControl?.errors?.required && !searchFailed">
        Este campo é obrigatório
    </div>
    <div class="invalid-feedback" *ngIf="formControl?.errors && !formControl?.errors?.required && !searchFailed">
        Campo inválido
    </div>

    <div class="text-muted small mt-1" *ngIf="searching">
        <i class="fas fa-spinner fa-spin"></i>
        Buscando...
    </div>
</div>
